import _ from 'lodash-es';
import Repre from '~/scripts/services/model/repre';

import {
	Keymaps,
	LanguageExtensions,
	Plugins,
	ThemeExtensions,
} from '@knitiv/code-editor';
// @ts-ignore

import { EditorView } from '@codemirror/view';

/* globals Knitiv */

class RepreController {
	/** @type {any} */
	#oldValues;

	/* @ngInject */
	/**
	 * @param {import('angular').IRootElementService} $element
	 * @param {import('angular').IFilterService} $filter
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {import('angular').ISCEService} $sce
	 * @param {any} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('~/scripts/services/ktranslate').KTranslate} KTranslate
	 * @param {any} Notification
	 * @param {import('./model/repre.service').default} RepreService
	 * @param {import('~/scripts/services/model/user').UserModel} User
	 */
	constructor(
		$element,
		$filter,
		$rootScope,
		$sce,
		$scope,
		$timeout,
		$translate,
		KTranslate,
		Notification,
		RepreService,
		User,
	) {
		this.$element = $element;
		this.$filter = $filter;
		this.$rootScope = $rootScope;
		this.$sce = $sce;
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.KTranslate = KTranslate;
		this.Notification = Notification;
		this.RepreService = RepreService;
		this.User = User;

		this.#oldValues = undefined;

		/** @type {boolean} */
		this.advanced = false;

		/** @type {?Function} */
		this.change = null;

		/** @type {string[]} */
		this.classTypeKid = [
			'K_NODE;STRING',
			'K_NODE;TEXT',
			'K_NODE;JSON',
			'K_NODE;HTML',
			'K_NODE;INTEGER',
			'K_NODE;DOUBLE',
			'K_NODE;DOUBLE8',
			'K_NODE;DATE',
			'K_NODE;HASH',
			'K_NODE;CRYPT',
			'K_NODE;BOOL',
		];

		/** @type {any} */
		this.component = undefined;

		/** @type {any} */
		this.customError = undefined;

		/** @type {boolean} */
		this.disabled = false;

		/** @type {?('simple' | 'advanced')} */
		this.forceView = null;

		this.jsonEditorOptions = {
			mode:    'tree',
			onError: (/** @type {any} */ error) => {
				this.Notification.warning({
					title:   this.$translate.instant('error.title'),
					message: error.toString(),
				});
			},
		};

		/** @type {any} */
		this.newRepre = undefined;

		/** @type {any} */
		this.ngModelCtrl = undefined;

		/** @type {any} */
		this.node = undefined;

		/** @type {any} */
		this.options = undefined;

		/** @type {boolean} */
		this.repreAdd = false;

		/** @type {boolean} */
		this.repreInsertOnlyFromRules = false;

		/** @type {any[]} */
		this.repreList = [];

		/** @type {number} */
		this.repreUniLangKey = -1;

		/** @type {boolean} */
		this.showTable = false;

		/** @type {boolean} */
		this.valid = true;

		/** @type {any} */
		this.validate = undefined;

		/** @type {Repre[]} */
		this.values = [];

		/** @type {boolean} */
		this.viewCode = false;

		this.mainRepre = RepreService.getRepre(this.values);
	}

	/**
	 * @param {Repre} newRepre
	 */
	add(newRepre) {
		let pass = true;
		if (Array.isArray(newRepre.lang)) {
			[newRepre.lang] = newRepre.lang;
		}
		// @ts-ignore
		if (!newRepre.lang.kid || newRepre.lang.kid === '0') {
			this.Notification.error({
				title:   this.$translate.instant('error.title'),
				message: this.$translate.instant('error.missing-repre-repre'),
			});
			pass = false;
		}
		else {
			if (!Array.isArray(this.values)) {
				this.values = [];
			}

			for (const repre of this.values) {
				if (repre.lang.kid === newRepre.lang.kid) {
					this.Notification.error({
						title:   this.$translate.instant('error.title'),
						message: this.$translate.instant('error.repre-already-exists'),
					});
					pass = false;
				}
			}
		}

		if (pass) {
			if (newRepre.type === 'K_NODE;BOOL' && !newRepre.value) {
				newRepre.value = false;
			}

			this.values.push(newRepre);
			if (this.node) {
				this.node.addRepre(newRepre);
			}

			this.newRepre = new Repre();
			this.mainRepre = this.RepreService.getRepre(this.values);
			this.ngModelCtrl.$setViewValue(this.values);
			this.ngModelCtrl.$validate();
			this.$timeout(() => {
				if (typeof this.change === 'function') {
					this.change();
				}
			});
		}
	}

	/**
	 * @param {Repre} repre
	 */
	changeType(repre) {
		if (this.node) {
			this.node.modRepre(repre.lang.kid, repre);
		}
		repre.value = undefined;
		this.$timeout(() => {
			if (typeof this.change === 'function') {
				this.change();
			}
		});
	}

	/**
	 * @param {Repre} repre
	 */
	changeValue(repre) {
		if (this.node) {
			this.node.modRepre(repre.lang.kid, repre);
		}
		this.mainRepre = this.RepreService.getRepre(this.values);
		this.ngModelCtrl.$validate();
		this.ngModelCtrl.$setDirty();

		this.$timeout(() => {
			if (typeof this.change === 'function') {
				this.change();
			}
		});
	}

	/**
	 * @param {Repre[]} repreData
	 * @returns {boolean}
	 */
	checkValues(repreData) {
		let pass = true;
		this.customError = undefined;

		if (Array.isArray(repreData) && repreData.length > 0) {
			for (const repre of repreData) {
				// Set default values while updating data type
				switch (repre.type) {
				case 'K_NODE;DATE': {
					if (typeof repre.value === 'string') {
						repre.value = repre.value ? new Date(repre.value) : undefined;
					}
					break;
				}
				case 'K_NODE;JSON': {
					try {
						if (typeof repre.value === 'string') {
							repre.value = JSON.parse(repre.value);
						}
					}
					catch {
						repre.value = undefined;
					}
					break;
				}
				case 'K_NODE;STRING':
				case 'K_NODE;TEXT':
				case 'K_NODE;HTML':
				case 'K_NODE;HASH':
				case 'K_NODE;CRYPT': {
					if (typeof repre.value === 'number') {
						repre.value = `${repre.value}`;
					}
					else if (typeof repre.value !== 'string' && repre.value !== undefined || !repre.value) {
						repre.value = undefined;
					}
					break;
				}
				case 'K_NODE;INTEGER':
				case 'K_NODE;DOUBLE':
				case 'K_NODE;DOUBLE8': {
					if (typeof repre.value === 'string' && /^-?\d+(\.\d+)?$/.test(repre.value.replace(',', '.'))) {
						if (repre.type === 'K_NODE;DOUBLE' || repre.type === 'K_NODE;DOUBLE8') {
							repre.value = Number.parseFloat(repre.value);
						}
						else if (repre.type === 'K_NODE;INTEGER') {
							repre.value = Number.parseInt(repre.value, 10);
						}
					}
					if (typeof repre.value !== 'number') {
						repre.value = undefined;
					}
					break;
				}
				case 'K_NODE;BOOL': {
					// nothing to do!
					break;
				}
				default: {
					throw new Error(`Unsupported type ${repre.type}`);
				}
				}

				// Check if required repre is filled
				if (
					this.validate?.rules
					&& repre?.lang?.kid
					&& repre.lang.kid in this.validate.rules
				) {
					if (this.validate.rules[repre.lang.kid].required && (repre.value === undefined || repre.value === '')) {
						pass = false;
						this.customError = this.$filter('sprintf')(
							this.$translate.instant('error.missing-repre-repre-label'),
							repre.lang.name,
						);
					}
					else if (this.validate.rules[repre.lang.kid].pattern) {
						const reg = new RegExp(this.validate.rules[repre.lang.kid].pattern);
						if (!reg.test(repre.value)) {
							pass = false;
							this.customError = this.$filter('sprintf')(
								this.$translate.instant('error.repre-pattern'),
								repre.lang.name,
								this.validate.rules[repre.lang.kid].pattern,
							);
						}
					}
				}
			}
		}

		if (this.validate?.rules) {
			for (const [k, rule] of Object.entries(this.validate.rules)) {
				if (
					rule.required
					&& k !== 'K_NODE;UNIV_LANG'
					&& repreData
					&& !repreData.some(repre => repre.lang.kid === k && (repre.value !== undefined && repre.value !== ''))
				) {
					pass = false;
					(async () => {
						try {
							const repreName = await this.KTranslate.request(null, k);
							this.$timeout(() => {
								this.customError = this.$filter('sprintf')(
									this.$translate.instant('error.missing-repre-lang'),
									repreName,
								);
							});
						}
						catch (/** @type {any} */ error) {
							console.error(error);
							this.customError = k;
						}
					})();
				}
			}
		}

		// Check if at least one repre is universal or language
		if (pass && (this.validate?.rules && this.validate?.rules['K_NODE;UNIV_LANG']?.required)) {
			pass = false;
			if (Array.isArray(repreData)) {
				for (const repre of repreData) {
					if (
						(repre.lang.kid === 'K_NODE;UNIVERSEL' || repre.lang.isa === 'K_NODE;LANGUE')
						&& repre.value !== '' && !_.isNil(repre.value)
					) {
						pass = true;
					}
				}
			}
			if (!pass) {
				this.customError = this.$translate.instant('error.missing-repre-unilang');
			}
		}

		return pass;
	}

	/**
	 * @param {number} index
	 */
	delete(index) {
		if (this.node) {
			this.node.delRepre(this.values[index].lang.kid);
		}
		else {
			this.values.splice(index, 1);
		}
		if (typeof this.mainRepre === 'object' && 'value' in this.mainRepre) {
			this.setName(this.mainRepre.value);
		}
		this.ngModelCtrl.$validate();
		this.ngModelCtrl.$setDirty();

		this.$timeout(() => {
			if (typeof this.change === 'function') {
				this.change();
			}
		});
	}

	/**
	 * @param {any} lang
	 * @returns {boolean}
	 */
	displayLang(lang) {
		return this.options.langs.some((/** @type {any} */ l) => l.kid === lang.kid && l.displayLang);
	}

	/**
	 * @returns {boolean}
	 */
	displayNewLang() {
		const length = this.values?.length ?? 0;
		let display = this.repreAdd && !this.disabled && (this.advanced || length === 0);
		if (this.validate?.rules && this.repreInsertOnlyFromRules && Object.keys(this.validate.rules).length <= length) {
			display = false;
		}
		return display;
	}

	async fetchRepreFromRules() {
		this.repreList.length = 0;
		if (this.validate?.rules) {
			Object.keys(this.validate.rules).map(async kid => {
				const name = await this.KTranslate.request(this.$scope, kid);
				this.repreList.push({ kid, name });
			});
		}
	}

	/**
	 * @param {Repre} repre
	 * @returns {string | undefined}
	 */
	getRepreName(repre) {
		if (this.disabled && this.options?.langs) {
			const lang = this.options.langs.find((/** @type {any} */ l) => l.kid === repre.lang.kid);
			if (lang) {
				return lang.name;
			}
		}

		return repre.lang.name;
	}

	initDate() {
		if (Array.isArray(this.values)) {
			for (const [index, elementData] of this.values.entries()) {
				if (elementData.type === 'K_NODE;DATE' && typeof elementData.value !== 'object') {
					this.values[index].value = new Date(elementData.value);
				}
			}
		}
	}

	isAdmin() {
		return this.$rootScope.context?.profil.admin;
	}

	onEditorSetup() {
		return [
			ThemeExtensions.oneLight,
			LanguageExtensions.html(),
			EditorView.lineWrapping,

			Plugins.FOLD_GUTTERS(),
			Plugins.MATCH_BRACKETS(),
			Plugins.AUTOCOMPLETION(),
			Plugins.CLOSE_BRACKETS(),
			Plugins.DRAW_SELECTION(),
			Plugins.DROP_CURSOR(),
			Plugins.HIGHLIGHT_ACTIVE_LINE_GUTTER(),
			Plugins.HIGHLIGHT_SELECTION_MATCHES(),
			Plugins.HIGHLIGHT_SPECIAL_CHARS(),
			Plugins.HISTORY(),
			Plugins.INDENT_ON_INPUT(),
			Plugins.MULTIPLE_CURSORS(),
			Plugins.RECTANGULAR_SELECTION(),
			Plugins.LINE_NUMBERS(),
			Plugins.KEYMAP.of(Keymaps.KNITIV_KEYMAP),
			// onChange,
		];
	}

	/**
	 * @param {any} item
	 */
	setLang(item) {
		if (item) {
			this.newRepre.type = item.type_kid;
		}
	}

	/**
	 * @param {any} value
	 */
	setName(value) {
		let key = -1;
		for (const [k, repre] of this.values.entries()) {
			if (repre.lang.kid === 'K_NODE;UNIVERSEL') {
				key = k;
			}
		}

		if (key < 0) {
			for (const [k, repre] of this.values.entries()) {
				if (repre.lang.isa === 'K_NODE;LANGUE' && repre.lang.kid === this.User.getContext().lang[0]) {
					key = k;
				}
			}
		}

		if (key < 0) {
			for (const [k, repre] of this.values.entries()) {
				if (repre.lang.isa === 'K_NODE;LANGUE') {
					key = k;
				}
			}
		}

		if (key < 0) {
			for (const k of this.values.keys()) {
				if (key < 0) {
					key = k;
				}
			}
		}

		if (value) {
			if (key >= 0) {
				this.values[key].value = value;
				this.repreUniLangKey = key;
			}
			else {
				const newRepre = new Repre();
				if (Array.isArray(newRepre.lang)) {
					[newRepre.lang] = newRepre.lang;
				}
				newRepre.type = this.newRepre.type || 'K_NODE;STRING';
				newRepre.value = value;
				this.values.push(newRepre);
				this.repreUniLangKey = 0;
			}
		}
	}

	toogleView() {
		this.advanced = !this.advanced;
	}

	/**
	 * @param {string} string
	 * @returns {any}
	 */
	trustAsHtml(string) {
		return this.$sce.trustAsHtml(string);
	}

	// noinspection JSUnusedGlobalSymbols
	$doCheck() {
		if (
			Array.isArray(this.values)
			&& this.values.length > 0
			&& this.values[0]?.value !== undefined
			// && (
			// 	(this.values[0]?.value !== undefined && this.#oldValues === undefined)
			// 	|| (!this.values[0]?.value && this.#oldValues !== undefined)
			// )
			&& !_.isEqual(this.#oldValues, this.values)
		) {
			this.checkValues(this.values);

			this.#oldValues = _.cloneDeep(this.values);
			this.ngModelCtrl.$validate();
			this.$element.trigger('change');
		}
	}

	/**
	 * @param {import('angular').IOnChangesObject} changes
	 */
	async $onChanges(changes) {
		if (changes.values && !changes.values.previousValue) {
			if (!Array.isArray(this.values)) {
				this.values = [];
			}

			this.initDate();
		}

		if (changes.disabled && this.disabled) {
			this.viewCode = false;
		}

		if (changes.forceView && this.forceView) {
			this.advanced = this.forceView === 'advanced';
		}

		if (changes.mainRepre && typeof this.mainRepre === 'object' && 'value' in this.mainRepre) {
			this.setName(this.mainRepre.value);
		}

		if (changes.repreInsertOnlyFromRules && this.repreInsertOnlyFromRules === true) {
			await this.fetchRepreFromRules();
			this.newRepre.lang = undefined;
		}
	}

	$onInit() {
		this.$timeout(() => {
			if (this.ngModelCtrl.$dirty) {
				this.ngModelCtrl.$validate();
			}
			// if (Array.isArray(this.values) && this.values.length > 0) {
			// 	this.valid = this.checkValues(this.values);
			// }
		});

		// retrocompatibilty for validate.rules.name
		if (this.validate?.rules?.name) {
			this.validate.rules['K_NODE;UNIV_LANG'] = this.validate.rules.name;
			delete this.validate.rules.name;
		}

		if (typeof this.newRepre !== 'object' || !(this.newRepre instanceof Repre)) {
			this.newRepre = new Repre();

			let universalExists = false;

			if (Array.isArray(this.values)) {
				universalExists = this.values.some(repre => repre.lang.kid === 'K_NODE;UNIVERSEL');
			}

			if (!(this.validate?.rules && this.validate?.rules['K_NODE;UNIV_LANG']?.required) || universalExists) {
				this.newRepre.lang.kid = '0';
				this.newRepre.lang.isa = undefined;
				this.newRepre.lang.name = '';
			}
		}

		this.ngModelCtrl.$validators.repre = (/** @type {any} */ modelValue, /** @type {any} */ viewValue) => {
			this.valid = this.checkValues(modelValue || viewValue);
			return this.valid;
		};

		this.initDate();
	}
}

export default RepreController;
